import Text22 from './Text22'
export default Text22
